import currency from 'currency.js';

let orders = {
  title: 'Vendas',
  title_s: 'Venda',
  recent: 'Vendas Recentes',
  month: 'Vendas do Mês',
  icon: 'mdi-view-list',
  actions: {
    view: 'Ver',
    edit: 'Editar',
    repeat: 'Repetir',
    cancel: 'Cancelar',
    uncancel: 'Descancelar',
    delete: 'Excluir'
  },
  new: {
    title: 'Nova Venda',
    edit: 'Editar Venda',
    orderData: 'Dados da Venda',
    reset: 'Limpar',
    save: 'Salvar',
    qty: 'Qtd',
    customer: {
      title: 'Dados do Cliente',
      none: 'Identificação (opcional)',
      name: 'Nome Completo',
      cep: 'CEP',
      address: 'Endereço',
      address_number: 'Número',
      com: 'Complemento',
      neighborhood: 'Bairro',
      city: 'Cidade',
      state: 'Estado',
      no_state: 'Selecione um Estado',
      country: 'País',
      phone: 'Telefone'
    },
    payment: {
      title: 'Pagamento',
      form: {
        title: 'Título',
        type: 'Tipo',
        value: 'Valor',
        percent: 'Percentual',
        card_tax: 'Taxa do Cartão',
        parcels: 'Parcelas',
        close: 'Fechar',
        save: 'Salvar',
        clear: 'Limpar',
        rules: {
          title: [
            v => !!v || 'Título é obrigatório',
            v => (v && v.length <= 25) || 'O Título deve ter menos que 25 caracteres'
          ],
          value: [
            v => !!v && parseFloat(v.toString().match(/\d+/g).join([])) > 0 || 'O Valor deve ser maior que 0'
          ],
          percent: [
            v => !!v && parseInt(v) > 0 && parseInt(v) <= 100 || 'Deve ser maior que 0 e menor que 100'
          ],
          tax_percent: [
            v => !!v && parseInt(v) <= 100 || 'Deve ser maior que 0 e menor que 100'
          ],
          parcels: [
            v => !!v && parseInt(v) > 0 && parseInt(v) <= 36 || 'Deve ser maior que 0 e menor que 36'
          ]
        },
        dyn_rules (type, max) {
          return {
            value: [
              v => !!v && (type <= 2 || max !== 0) || 'Não há nenhum Valor a ser Pago.',
              v => !!v && currency(v, { separator: " ", decimal: ",", symbol: "R$" }) > 0 || 'O Valor deve ser maior que 0',
              v => !!v && (type <= 2 || currency(v, { separator: " ", decimal: ",", symbol: "R$" }).value <= parseFloat(max).toFixed(2)) || 'O Valor deve ser menor que o Total restante (' + currency(max, { separator: " ", decimal: ",", symbol: "R$" }).format() + ')',
            ]
          }
        }
      },
      actions: {
        edit: 'Editar',
        delete: 'Excluir (clique duplo)',
        restore: 'Restaurar'
      },
      income: {
        title: 'Débitos',
        add: 'Adicionar Débito',
        subtotal: 'Subtotal (Pedido)'
      },
      paid: {
        title: 'Créditos',
        add: 'Adicionar Crédito',
        types: {
          discount: {
            title: 'Desconto',
            currency: 'Desconto (R$)',
            percent: 'Desconto (%)'
          },
          payment: {
            title: 'Pagamento',
            debtcard: 'Cartão de Débito',
            creditcard: 'Cartão de Crédito',
            money: 'Dinheiro',
            transfer: 'Pix / Transferência'
          }
        },
        methods: {
          title: 'Forma de Pagamento',
          undefined: 'Não definido',
          money: 'Dinheiro',
          debit: 'Débito',
          credit: 'Crédito'
        }
      },
      prices: {
        total: 'Total:',
        paid: 'Pago:',
        debt: 'A Receber:'
      }
    },
    order: {
      title: '',
      list: 'Venda',
      newitem: 'Novo Item',
      delete: 'Excluir',
      duplicate: 'Duplicar',
      additional: 'Adicionais',
      additional_un: 'Adicionais por Unidade',
      add: 'Adicionar',
      edit: 'Editar',
      obs: 'Observações',
      autocomplete: 'Buscar',
      groups: {
        no_group: {
          services: 'Não Agendado',
          items: 'Não Enviado'
        },
        actions: {
          view: 'Ver',
          edit: 'Editar',
          delete: 'Excluir'
        }
      },
      no_results (title) {
        return `Nenhum ${title} encontrado`
      },
      toolbar: {
        check_all: 'Selecionar Todos',
        uncheck_all: 'Deselecionar Todos',
        actions: {
          title: 'Ações',
          services: {
            schedule: 'Agendar'
          },
          items: {
            deliver: 'Enviar'
          }
        }
      }
    },
    type: {
      title: 'Entrega'
    },
    delivery_fee: 'Taxa de Entrega',
    table: 'Mesa',
    other_fee: 'Outros',
    subtotal: 'Subtotal',
    total: 'Total',
    actions: {
      title: 'Ações',
      paid: 'Pagamento Efetuado',
      print: 'Imprimir Pedido'
    },
    commissions: {
      title: 'Comissões',
      add: 'Nova Comissão',
      form: {
        employee: 'Profissional',
        service: 'Produto / Serviço',
        noService: 'Nenhum Serviço selecionado',
        percent: 'Percentual',
        value: 'Valor',
        rules: {
          employee: [
            v => !!v || 'Profissional é obrigatório'
          ],
          service: [
            v => !!v || 'Serviço é obrigatório'
          ],
          percent: [
            v => !!v && parseInt(v.toString().match(/\d+/g).join([])) > 0 || 'O Percentual deve ser maior que 0',
            v => !!v && parseInt(v.toString().match(/\d+/g).join([])) <= 100 || 'O Percentual deve ser menor que 100'
          ],
          value: [
            v => !!v && parseFloat(v.toString().match(/\d+/g).join([])) > 0 || 'O Valor deve ser maior que 0'
          ]
        }
      }
    },
    rules: {
      nameRules: [
        v => !!v || 'Nome é obrigatório',
        v => (v && v.length <= 27) || 'O Nome deve ter menos que 27 caracteres'
      ],
      emailRules: [
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      phoneRules: [
        v => (v && v.length !== 11) || 'O Telefone deve ter 11 caracteres'
      ]
    }
  },
  view: {
    unread: 'Não Lido',
    order: 'Venda',
    order_title: 'Pedido',
    close: 'Fechar',
    copy: 'Copiar',
    print: 'Imprimir',
    history: {
      created: 'Criado',
      edited: 'Editado',
      scheduled: 'Agendado',
      ready: 'Pronto',
      delivery: 'A Caminho',
      delivered: 'Entregue',
      completed: 'Concluído',
      canceled: 'Cancelado',
      deleted: 'Excluido',
      payment: 'Pagamento Efetuado',
      unknown: 'Desconhecido'
    },
    adc: 'Adicionais'
  },
  datatable: {
    search: 'Pesquisar',
    no_data: 'Nenhuma Venda recente.',
    no_results: 'Nenhum resultado encontrado',
    items_per_page: 'Pedidos por página',
    headers: {
      id: 'ID',
      datetime: 'Data',
      customer: 'Cliente',
      type: 'Tipo',
      status: 'Estado',
      paid: 'Pagamento',
      total: 'Total',
      action: 'Ações',
      history: 'Histórico'
    }
  },
  results: {
    title: 'Resultados',
    all: 'Todos',
    canceled: 'Cancelados',
    deleted: 'Excluidos',
    unpaid: 'Não Pagos'
  },
  type: {
    delivery: 'Delivery',
    local: 'Local'
  },
  status: {
    waiting: 'Aguardando',
    scheduled: 'Agendado',
    adjourned: 'Adiado',
    execution: 'Em Execução',
    ready: 'Pronto',
    delivery: 'A Caminho',
    delivered: 'Entregue',
    completed: 'Concluído',
    canceled: 'Cancelado',
    deleted: 'Excluido',
    unknown: 'Desconhecido'
  },
  payment: {
    pending: 'Pendente',
    half: 'Parcial',
    paid: 'Pago'
  },
  dialog: {
    ready: function (id) {
      return `Tem certeza que o Pedido #${id} está pronto?`
    },
    preparation: function (id) {
      return `Tem certeza que o Pedido #${id} está sendo preparado?`
    },
    delivery: function (id) {
      return `Tem certeza que o Pedido #${id} saiu para entrega?`
    },
    delivered: function (id) {
      return `Tem certeza que o Pedido #${id} foi entregue?`
    },
    paid: function (id) {
      return `Tem certeza que o Pagamento do Pedido #${id} foi efetuado?`
    },
    cancel: function (id) {
      return `Tem certeza que deseja cancelar o Pedido #${id}`
    },
    delete: function (id) {
      return `Tem certeza que deseja excluir o Pedido #${id}`
    }
  },
  messages: {
    error: {
      not_found: 'Venda não encontrada'
    }
  }
}

export default orders
